/**
 * Mindest-Touch-Höhe der Mitgliederseiten.
 * Im Theme gibt es kein size-Token; die übrigen 44er-Werte der Mitgliederzeilen liegen hier.
 */
export const HIT_TARGET_MIN = 44;

/**
 * Ohne enforceHitTarget bleibt das Label nur gesetzt, wenn der Aufrufer eines übergibt.
 * Der Titel wird nicht als Ersatzlabel benutzt. Trefferfläche und Button-Rolle nur für die Mitgliederseiten.
 * Ohne diese Flags bleibt die Zeile wie auf der Basis: keine Rolle, keine Mindesthöhe.
 */
export function listRowPressableA11y(input: {
  accessibilityLabel?: string;
  enforceHitTarget?: boolean;
}): {
  accessibilityLabel: string | undefined;
  accessibilityRole: "button" | undefined;
  hitSlop: number | undefined;
  minHeight: number | undefined;
} {
  return {
    accessibilityLabel: input.accessibilityLabel,
    accessibilityRole: input.enforceHitTarget ? "button" : undefined,
    hitSlop: input.enforceHitTarget ? 8 : undefined,
    minHeight: input.enforceHitTarget ? HIT_TARGET_MIN : undefined,
  };
}

/**
 * Nicht tippbare Zeile: Label nur, wenn der Aufrufer eines übergibt.
 * Tippbare Zeile trägt das Label auf dem Pressable, der Inhalt bleibt ohne accessible.
 */
export function listRowContentA11y(input: {
  accessibilityLabel?: string;
  pressable: boolean;
}): { accessible?: boolean; accessibilityLabel?: string } {
  if (input.pressable || !input.accessibilityLabel) return {};
  return { accessible: true, accessibilityLabel: input.accessibilityLabel };
}
